import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function usePersonnelEventsQuery({
  params = {},
  personnelId,
  queryOptions,
}) {
  return useQuery({
    queryKey: ['personnel', personnelId, 'events', params],
    queryFn: async () => {
      const response = await axios.get(`/personnel/${personnelId}/events`, {
        params,
      });

      return response.data;
    },
    keepPreviousData: true,
    select: (data) =>
      formatData({ data, resourceTypes: ['profilePhoto', 'user'] }),
    ...queryOptions,
  });
}
